import { useEffect, useRef } from "react";

import { confirmable } from "react-confirm";
import { useTranslation } from "react-i18next";

import { CheckIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import { Divider } from "simplydo/react/ui/divider";
import { Icon } from "simplydo/react/ui/icon";
import { Input } from "simplydo/react/ui/input";
import {
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from "simplydo/react/ui/modal";

type CopyToClipboardModalProps = {
  show?: boolean;
  proceed?: () => void;
  dismiss?: () => void;
  text: string;
};

const CopyToClipboardModal = ({
  show,
  proceed,
  dismiss,
  text,
}: CopyToClipboardModalProps) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!show) return;
    const input = inputRef.current;
    if (!input) return;
    input.focus();
    input.select();
  }, [show, text]);

  const close = () => {
    (proceed ?? dismiss ?? (() => {}))();
  };

  return (
    <Modal
      open={!!show}
      onClose={dismiss ?? (() => {})}
      size="small"
      className="no-scroll"
      closeOnDimmerClick={false}
    >
      <ModalHeader>{t("generic.copyManually")}</ModalHeader>
      <ModalContent>
        <p>{t("generic.copyManuallyHint")}</p>
        <Divider hidden />
        <Input
          fluid
          readOnly
          autoFocus
          value={text}
          ref={inputRef}
          onFocus={(e) => e.target.select()}
        />
      </ModalContent>
      <ModalActions>
        <Button onClick={close} color="primary">
          <Icon icon={CheckIcon} /> {t("generic.done")}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default confirmable(CopyToClipboardModal);
